var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"to":{
    name: 'FeedbackForm',
    params: { id: _vm.item.id }
  }},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t(`feedbacks.processTypes.${_vm.item.processType}`))+" – "+_vm._s(_vm.feedbackTitle))]),_c('v-list-item-subtitle',[_vm._v(" "+_vm._s(_vm.$t('feedbacks.recipient'))+": "+_vm._s(_vm.item.recipient)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.$t('feedbacks.donor'))+": "+_vm._s(_vm.item.donor)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }